import React from "react";
import CustomBox from "../../CustomComponents/CustomBox/CustomBox";
import CustomPaper from "../../CustomComponents/CustomPaper/CustomPaper";
import CustomCard from "../../CustomComponents/CustomCard/CustomCard";
import CustomCardContent from "../../CustomComponents/CustomCardContent/CustomCardContent";
import CustomButton from "../../CustomComponents/CustomButton/CustomButton";
import { useStyles } from "../../../assets/jss/ContentDetails";
import CustomFormControl from "../../CustomComponents/CustomFormControl/CustomFormControl";
import {
  CustomRadio,
  CustomRadioGroup,
} from "../../CustomComponents/CustomRadio/CustomRadio";
import clsx from "clsx";
import { CustomCheckCircleIcon } from "../../CustomComponents/CustomIcon/CustomIcon";
import CustomDivider from "../../CustomComponents/CustomDivider/CustomDivider";
import { useTranslation } from "react-i18next";

export default function QuizComponentPreview(props:any) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [quizStart, setQuizStart] = React.useState(false);
  const [activeStep, setActiveStep] = React.useState(null);
  const [content, setContent] = React.useState(null);
  const [quiz, setQuiz] = React.useState(null);
  const [currentQuiz, setCurrentQuiz] = React.useState(null);
  const [currentAnswer, setCurrentAnswer] = React.useState(null);

  const handleNext = async (isSubmit) => {
    if (
      !isSubmit &&
      activeStep &&
      activeStep > 0 &&
      activeStep <= quiz.length
    ) {
      setActiveStep((prevActiveStep) =>
        prevActiveStep < quiz.length ? prevActiveStep + 1 : quiz.length
      );
    } else {
      setQuizStart(false);
      setActiveStep(1);
    }
  };

  React.useEffect(() => {
    if (props.content) {
      setContent(props.content);
      setQuiz(props.content.quizQuestions);
    }
  }, [props.content]);

  React.useEffect(() => {
    if (quizStart && activeStep > 0 && activeStep <= quiz.length) {
      setCurrentQuiz(quiz[activeStep - 1]);
      if (quiz[activeStep - 1] && quiz[activeStep - 1].selectedAnswerId) {
        setCurrentAnswer(
          quiz[activeStep - 1].quizAnswers.findIndex(
            (item) => item._id === quiz[activeStep - 1].selectedAnswerId
          )
        );
      }
    }
  }, [activeStep, quizStart]);

  React.useEffect(() => {
    if (quizStart) {
      setActiveStep(1);
    }
  }, [quizStart]);

  React.useEffect(() => {
    if (!quizStart) {
      setQuizStart(true);
    }
  }, []);

  return (
    <>
      <CustomPaper elevation={0}>
        <CustomCard elevation={0} className={classes.cardContentWrapper}>
          <CustomCardContent className={classes.cardContent}>
            <>
              <CustomBox className={classes.cardContentBody}>
                {activeStep && currentQuiz && quizStart ? (
                  <>
                    <CustomBox className={classes.quizWrapper}>
                      <CustomBox className={classes.quizQuestionTitle}>
                      {t("QUESTION")} {activeStep}:
                      </CustomBox>
                      <CustomBox className={classes.quizQuestionText}>
                        {currentQuiz[`question`]}
                      </CustomBox>
                      <CustomBox className={classes.quizOptions}>
                        <CustomFormControl fullWidth component="fieldset">
                          <CustomRadioGroup
                            row
                            aria-label="optionSet"
                            name="optionSet"
                            value={`${currentAnswer}`}
                          >
                            {currentQuiz &&
                              currentQuiz.quizAnswers &&
                              currentQuiz.quizAnswers.map((item, index) => {
                                return (
                                  <CustomBox
                                    flexGrow={1}
                                    key={`${index}-quizOptionRadio`}
                                    className={classes.quizOption}
                                  >
                                    <CustomRadio
                                      checkedIcon={<CustomCheckCircleIcon />}
                                      disabled={true}
                                      color="primary"
                                      value={`${index}`}
                                      className={clsx(
                                        classes.customRadio,
                                        item.isCorrect
                                          ? classes.currectAnswer
                                          : currentAnswer === index &&
                                            !item.isCorrect
                                          ? classes.inCorrectAnswer
                                          : null
                                      )}
                                    />
                                    <CustomBox className={classes.quizOptionText}>{item.answerOption}</CustomBox>
                                  </CustomBox>
                                );
                              })}
                          </CustomRadioGroup>
                        </CustomFormControl>
                      </CustomBox>
                    </CustomBox>
                  </>
                ) : null}
              </CustomBox>
              <CustomDivider className={classes.spacer} />
              <CustomBox mt={0} mb={2} className={classes.cardContentFooter}>
                {quizStart &&
                  activeStep &&
                  activeStep > 0 &&
                  activeStep <= quiz.length && (
                    <>
                      {activeStep < quiz.length ? (
                        <CustomButton
                          variant="contained"
                          color="primary"
                          onClick={() => handleNext(activeStep === quiz.length)}
                          className={classes.primaryButtonXl}
                          defaultrounded="true"
                        >
                          {activeStep < quiz.length ? t("NEXT") : null}
                        </CustomButton>
                      ) : null}
                    </>
                  )}
              </CustomBox>
            </>
          </CustomCardContent>
        </CustomCard>
      </CustomPaper>
    </>
  );
}
